module.exports = __webpack_public_path__ + "img/vm-energie.25a66c52.png";